module.exports = __webpack_public_path__ + "img/performance-5.a3ddb55b.png";